/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  FunctionResourceDefinition,
  FunctionResourceDefinition$inboundSchema,
} from "./functionresourcedefinition.js";

/**
 * A polymorphic resource - currently only function resources are supported
 */
export type Resource = {
  /**
   * A function resource
   */
  functionResourceDefinition?: FunctionResourceDefinition | undefined;
};

/** @internal */
export const Resource$inboundSchema: z.ZodMiniType<Resource, unknown> = z.pipe(
  z.object({
    function_resource_definition: z.optional(
      FunctionResourceDefinition$inboundSchema,
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "function_resource_definition": "functionResourceDefinition",
    });
  }),
);

export function resourceFromJSON(
  jsonString: string,
): SafeParseResult<Resource, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Resource$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Resource' from JSON`,
  );
}
